/**
 * Combined reducer for central store creation
 * Mapping subReducers into corresponding key of central state store
 */
import {combineReducers} from 'redux'
import userProfileReducer from './user-profile-reducer'
import materialUsageReducer from './material-usage-reducer'
import printerStatusReducer from "./printer-status-reducer"
import printedModelsReducer from './printed-models-reducer'
import printerStatisticsReducer from './printer-statistics-reducer'
import subscriptionReducer from './subscription-reducer';
import lightboxReducer from './lightbox-reducer';
import printRecordSharingReducer from './print-record-sharing-reducer';

export default combineReducers({
    userProfile: userProfileReducer,
    materialUsage: materialUsageReducer,
    printerStatus: printerStatusReducer,
    printedModels: printedModelsReducer,
    printerStatistics: printerStatisticsReducer,
    subscriptions: subscriptionReducer,
    lightbox: lightboxReducer,
    printRecordSharing: printRecordSharingReducer
})


// WEBPACK FOOTER //
// ./src/reducers/index.js